/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { StyledIframe } from "src/components/Block/BlockTypes/LinkBlock/styles";

interface Props {
  embedId: string;
  blockId: string;
  disableMouse: boolean;
}

export const SpotifyEmbed = ({ embedId, blockId, disableMouse }: Props) => {
  return (
    <StyledIframe
      title={`spotify-${embedId}`}
      src={`https://open.spotify.com/embed/${embedId}`}
      frameBorder="0"
      allowFullScreen
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      style={{
        visibility: "visible",
        height: "100%",
        width: "100%",
      }}
      disableMouse={disableMouse}
      id={`spotify-${blockId}`}
    />
  );
};
